export default __webpack_public_path__ + "static/media/080_finish_bad.first.980e24c4.webp";